import { motion } from "framer-motion";
import ProfileCardSkeleton from "./ProfileCardSkeleton";
import Nodata from "@component/NodataTailwind";
import { cn } from "@/lib/utils";


const ProfileCardWrapper = ({
  data = [],
  render,
  loading = false,
  showNoData = false,
  children,
  // cardsPerRow = 4, // default to 4 per row
  motionClassName='',
  className='',
}) => {
  // Always show 2 rows of skeletons
  // const skeletonArray = Array.from({ length: cardsPerRow * 2 });

const skeletonArray = Array.from({ length: 8 });

  if (!data?.length && showNoData && !loading) {
    return <Nodata />;
  }

  return (
    <>
      <div 
        // className="font-sans grid gap-4"
        // style={{
        //   gridTemplateColumns: `repeat(${cardsPerRow}, minmax(0, 1fr))`,
        // }}
        className={cn('font-sans grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4',className)}
      >
        {(loading ? skeletonArray : data)?.map((item, index) => (
          <div
            key={index}
            className="cursor-pointer mt-2"
          >
            {loading ? (
              <ProfileCardSkeleton />
            ) : (
              <motion.div
              className={motionClassName}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.4,
                  delay: index * 0.05, // staggered effect
                  ease: "easeOut",
                }}
              >
                {render(item, index)}
              </motion.div>
            )}
          </div>
        ))}
      </div>
      {children}
    </>
  );
};

export default ProfileCardWrapper;
